import { Box } from '@mui/material';

export default function AnalyticReportContainer() {
  return (
    <main id="main">
      <Box sx={{ width: '100%', height: '100%', p: 3 }}>
        <iframe
          width="100%"
          height="2125"
          src="https://lookerstudio.google.com/embed/reporting/0ffa145a-6f59-4f3e-8625-e86bad43eccd/page/kIV1C"
          style={{ border: 0, outline: 0, width: '100%' }}
          allowFullScreen
          sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        />
      </Box>
    </main>
  );
}
